// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bg-logo-common.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/bg-logo-common-sm.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Freemium_subscription__pXm-p {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 130px 17% 100px;
  overflow-x: hidden;
  background-color: #f5f5ff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.Freemium_subscription__pXm-p.Freemium_justify-center__934Z1 {
  justify-content: center;
}

.Freemium_header__ug9OA {
  position: fixed;
  top: 0;
  left: 0;
}

.Freemium_back__ElIIv {
  position: absolute;
  left: 17%;
  top: 80px;
}

.Freemium_notices__nn8C9 {
  position: fixed;
  z-index: 1;
  bottom: 0;
  width: 100vw;
  border-top: 1px solid #d8d8ff;
  background: #fff;
  font-size: 14px;
  font-weight: 300;
  line-height: 24px;
}
.Freemium_notices__nn8C9 .Freemium_collapsible__l1aN0 {
  padding: 12px 30px;
  background: #fff;
}
.Freemium_notices-title__Mv42K {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #00007a;
}

@media screen and (max-width: 900px) {
  .Freemium_notices-opened__Xbibr {
    position: absolute;
    height: 80vh;
  }
}
@media screen and (max-width: 600px) {
  .Freemium_subscription__pXm-p {
    padding: 100px 20px 150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: bottom;
    background-size: 100%;
  }
  .Freemium_header__ug9OA {
    position: absolute;
    padding: 12px 20px 18px;
  }
  .Freemium_back__ElIIv {
    left: 5px;
    top: 50px;
  }
  .Freemium_progress__zGCzt {
    margin-bottom: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/Freemium.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBCXS;EDYT,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;AAIF;AAFE;EACE,uBAAA;AAIJ;;AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;AAGF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AAGF;;AAAA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGF;AADE;EACE,kBAAA;EACA,gBAAA;AAGJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cChDO;ADkDX;;AAEA;EACE;IACE,kBAAA;IACA,YAAA;EACF;AACF;AAEA;EACE;IACE,yBAAA;IACA,yDAAA;IACA,2BAAA;IACA,qBAAA;EAAF;EAGA;IACE,kBAAA;IACA,uBAAA;EADF;EAIA;IACE,SAAA;IACA,SAAA;EAFF;EAKA;IACE,mBAAA;EAHF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.subscription {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  padding: 130px 17% 100px;\n  overflow-x: hidden;\n  background-color: colors.$primary1;\n  background-image: url(../../assets/bg-logo-common.svg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n\n  &.justify-center {\n    justify-content: center;\n  }\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.back {\n  position: absolute;\n  left: 17%;\n  top: 80px;\n}\n\n.notices {\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  width: 100vw;\n  border-top: 1px solid colors.$primary2;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 24px;\n\n  .collapsible {\n    padding: 12px 30px;\n    background: #fff;\n  }\n\n  &-title {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .notices-opened {\n    position: absolute;\n    height: 80vh;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .subscription {\n    padding: 100px 20px 150px;\n    background-image: url(../../assets/bg-logo-common-sm.svg);\n    background-position: bottom;\n    background-size: 100%;\n  }\n\n  .header {\n    position: absolute;\n    padding: 12px 20px 18px;\n  }\n\n  .back {\n    left: 5px;\n    top: 50px;\n  }\n\n  .progress {\n    margin-bottom: 28px;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"subscription": `Freemium_subscription__pXm-p`,
	"justify-center": `Freemium_justify-center__934Z1`,
	"header": `Freemium_header__ug9OA`,
	"back": `Freemium_back__ElIIv`,
	"notices": `Freemium_notices__nn8C9`,
	"collapsible": `Freemium_collapsible__l1aN0`,
	"notices-title": `Freemium_notices-title__Mv42K`,
	"notices-opened": `Freemium_notices-opened__Xbibr`,
	"progress": `Freemium_progress__zGCzt`
};
export default ___CSS_LOADER_EXPORT___;
